<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_scout') }}
        game-preview-settings(v-for="({ theme, num }, index) in parameters.examples" :key="`${theme.id}_${index}`")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                span(slot="value") {{ num }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_themeForExample', {example: null}) }}
                span(slot="value") {{ getThemeName(theme.name) }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import { camelCase } from 'lodash';

    export default {
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        mixins: [GamePreviewMixin],
        props: ['parameters', 'exerciseId', 'type'],
        methods: {
            getThemeName(name) {
                return this.$i18n.t('trainer.trainer_gameFormSetting_' + camelCase(name));
            },
        },
    }
</script>
